module.exports = __webpack_public_path__ + "vue/auth/img/praqt-logo.a6725d3c.png";